import { commonRequest, adminRequest } from '@admin/utils/http/axios'

/**
  语言配置option
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387183927
 */
export const queryLangOption = (params = {}): any => {
  return commonRequest.get({
    url: '/api/multilingual/language-config/option',
    data: params,
  })
}

/**
  （翻译）调用智能体
   接口地址：https://app.apifox.com/link/project/3349231/apis/api-386773801
 */
export const translateContentLangs = (data = {}): any => {
  return commonRequest.post({
    url: '/api/multilingual/intelligent-agent/call',
    data: {
      sn: 'TRANS-001',
      data,
    },
  })
}

/**
  （翻译）调用智能体
   接口地址：https://app.apifox.com/link/project/3349231/apis/api-386773801
 */
export const translateLangContents = (data = {}): any => {
  return commonRequest.post({
    url: '/api/multilingual/intelligent-agent/call',
    data: {
      sn: 'TRANS-002',
      data,
    },
  })
}

/**
  获取语言配置列表
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387106509
 */
export const queryLangList = (params = {}): any => {
  return commonRequest.get({
    url: '/api/multilingual/language-config/list',
    params,
  })
}

/**
  获取语言配置筛选
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387890249
 */
export const queryOptionGroups = (params = {}): any => {
  return commonRequest.get({
    url: '/api/multilingual/language-config/filter',
    params,
  })
}

/**
  创建语言配置
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387106510
 */
export const createLang = (data = {}): any => {
  return commonRequest.post({
    url: '/api/multilingual/language-config/create',
    data,
  })
}

/**
  更新语言配置
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387106512
 */
export const updateLang = (data = {}): any => {
  return commonRequest.post({
    url: '/api/multilingual/language-config/update',
    data,
  })
}

/**
  删除语言配置
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387106513
 */
export const delLang = (data = {}): any => {
  return commonRequest.post({
    url: '/api/multilingual/language-config/delete',
    data,
  })
}

/**
  动态文本获取
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387226180
 */
export const queryContentLangs = (params = {}): any => {
  return commonRequest.get({
    url: '/api/multilingual/dynamic_text/list',
    params,
  })
}

/**
  动态文本保存
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-387226249
 */
export const updateContentLangs = (data = {}): any => {
  return commonRequest.post({
    url: '/api/multilingual/dynamic_text/save',
    data,
  })
}

/**
  颜色
  接口地址：https://app.apifox.com/link/project/1312103/apis/api-389715807
 */
export const queryColorLang = (data = {}): any => {
  return adminRequest.post({
    url: '/mcapi/goods/property/color/getData',
    data,
  })
}

/**
  品类
  接口地址：https://app.apifox.com/link/project/1312103/apis/api-389712164
 */
export const queryTypeLang = (type, data = {}): any => {
  return adminRequest.post({
    url: `/mcapi/goods/property/${type}/getData`,
    data,
  })
}

/**
  新增多语言
  接口地址：https://app.apifox.com/link/project/1312103/apis/api-389710933
 */
export const updateAttributeLang = (data = {}): any => {
  return adminRequest.post({
    url: '/mcapi/goods/property/configurationTranslation/translation',
    data,
  })
}

/**
  key 筛选option
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-392520255
 */
export const queryTranslationKeyFilters = (params = {}): any => {
  return commonRequest.get({
    url: '/api/multilingual/translation-key/option',
    params,
  })
}

/**
  key 列表
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-389788110
 */
export const queryTranslationKeyList = (params = {}): any => {
  return commonRequest.get({
    url: '/api/multilingual/translation-key/list',
    params,
  })
}

/**
  动态表格导入 key
  POST /api/multilingual/translation-key/import-excel
  接口ID：389784536
  接口地址：https://app.apifox.com/link/project/3349231/apis/api-389784536
 */
export const importTranslationKey = (data = {}): any => {
  return commonRequest.post({
    url: '/api/multilingual/translation-key/import-excel',
    data,
    headers: {
      'Content-type': 'multipart/form-data',
    },
  })
}
